/**
 * L'arrondi au centime, en un seul exemplaire.
 *
 * Il vivait en onze copies identiques, une par domaine. Aucune n'avait dérivé,
 * mais la correction de l'arrondi des devis — qui a dû aligner le noyau sur
 * l'arithmétique de Postgres — a montré le coût de cette dispersion : changer
 * la règle demandait onze modifications cohérentes, et en oublier une seule ne
 * produisait aucune erreur, juste un centime d'écart quelque part.
 *
 * Deux limites connues, écrites ici pour qu'elles ne se redécouvrent pas :
 *
 *   · `Math.round` arrondit vers +∞ quand Postgres s'éloigne de zéro. Les deux
 *     coïncident sur des montants positifs et divergent sur un `.5` négatif —
 *     une ligne de remise à prix négatif. Le corriger demanderait une
 *     arithmétique décimale ; la base reste l'autorité sur ce qu'elle stocke.
 *   · `n * 100` est un produit flottant : `round2(1.005)` rend 1 et non 1,01,
 *     parce que `1.005 * 100` vaut 100,49999999999999 en binaire. Borné aux
 *     valeurs à trois décimales exactes, et sans portée tant que l'arrondi
 *     s'applique ligne par ligne plutôt qu'à un cumul.
 */
export const round2 = (n: number): number => Math.round(n * 100) / 100;

/** L'arrondi au dixième, pour les pourcentages qui s'affichent ainsi. */
export const round1 = (n: number): number => Math.round(n * 10) / 10;
